/// <amd-module name="CodeCoverage/CodeCoverageCiFileCoveragePane/CodeEditorGutterAdornments/AdornmentToolTipContainerHost" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ITooltipProps, Tooltip } from "VSSUI/TooltipEx";
import { IOrigin, Location } from "VSSUI/Utilities/Position";

export class AdornmentToolTipContainerHost {
    public static createToolTipContainer(helpText: string): HTMLElement {
        const toolTipContainer = document.createElement("div");
        toolTipContainer.className = "cc-adornment-tooltip-container";

        ReactDOM.render(AdornmentToolTipContainerHost.getToolTipContent(helpText), toolTipContainer);

        return toolTipContainer;
    }

    private static getToolTipContent(helpText: string): JSX.Element {
        return (
            <Tooltip
                className="gutter-adornment-tooltip-host"
                text={helpText}
                renderContent={() => <span> {helpText} </span>}
                anchorOrigin={{
                    horizontal: Location.end,
                    vertical: Location.start
                }}
            >
                <div className="gutter-adornment-tooltip-host-childnode" />
            </Tooltip>
        );
    }
}
